import React from 'react';
import VoiceOverArtistComponent from '../components/VoiceOverArtist';

import { AddonsContextConsumer } from '../../../../context/AddonsContext';

function VoiceOverArtist(props) {
  return (
    <AddonsContextConsumer>
      {
      ({
        constants: { VOICE_OVER_ARTIST },
        actions: { getBillingEntityCode }
      }) =>
      <VoiceOverArtistComponent
        {...props}
        VOICE_OVER_ARTIST={VOICE_OVER_ARTIST}
        getBillingEntityCode={getBillingEntityCode} />}


    </AddonsContextConsumer>);

}

export default VoiceOverArtist;